export default __webpack_public_path__ + "static/media/travel.55a17373.png";